module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACgSURBVEhL7ZRRCoQwDAV7uz26LHsLvUfXvDKGfpQqJh+74ICgMW9qibQ8XKbW+vkGsPwb1Rj6QqAaQ08IeWwnq12vJu2hJ8Th0SJN2tM6gvSeJu3RkHh3C8sv8vA4n0cE/D+4gP4MDY/8lOGQz7DQRn6K5PoYYtch/6fDsy37OWX38zPnDrgdynngdSjngdehnAdeh3IeGixuP3MekihlBzBskM8PPLerAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-roller/light/24.png
// module id = 2312
// module chunks = 2